import { memo, useCallback, useEffect, useMemo, useState } from 'react';
import { useMapEvents } from 'react-leaflet';
import { useAction, usePartialAppSelector } from 'shared/hooks/redux/hooks';
import { setMapCenterAndZoom, setMapSize } from 'shared/map/model/slice';
import { a2l, l2a } from 'shared/map/lib/utils';
import { select_device_map } from 'shared/map/model/selectors';
import { debounce } from 'throttle-debounce';
import { useMounted } from 'shared/hooks/utils';
export const MapControl = memo(function MapControl(props) {
    const { device_id, width, height } = props;
    const isMounted = useMounted();
    const map_state = usePartialAppSelector(select_device_map, device_id);
    const [prevState, setPrevState] = useState(map_state);
    const onWantCenterAndZoom = useAction(setMapCenterAndZoom);
    const onSetMapSize = useAction(setMapSize);
    useEffect(() => {
        if (isMounted.current) {
            if (map_state && prevState && map_state?.center) {
                if (prevState.zoom != map_state.zoom &&
                    prevState.center != map_state.center) {
                    map.setView(a2l(map_state.center), map_state.zoom);
                }
                else if (prevState.center != map_state.center) {
                    map.setView(a2l(map_state.center), map.getZoom());
                }
                else if (prevState.zoom != map_state.zoom) {
                    map.setView(map.getCenter(), map_state.zoom);
                }
                if (map_state.highlight_rings) {
                    if (map_state.highlight_rings.loc != prevState?.highlight_rings?.loc) {
                        map.setView(a2l(map_state.highlight_rings.loc), map.getZoom());
                    }
                }
                setPrevState(map_state);
            }
            if (map_state && prevState == null && map_state?.center) {
                setPrevState(map_state);
                map.setView(a2l(map_state.center), map_state.zoom);
            }
        }
    }, [map_state]);
    useEffect(() => {
        if (isMounted.current) {
            if (map_state) {
                map.setView(a2l(map_state.center), map_state.zoom);
            }
        }
    }, [device_id]);
    const _onWantCenterAndZoom = useCallback(() => {
        if (isMounted.current) {
            onWantCenterAndZoom({
                center: l2a(map.getCenter()),
                zoom: map.getZoom(),
                device_id,
            });
        }
    }, [device_id]);
    const updateCenterAndZoom = useMemo(() => debounce(1e3, _onWantCenterAndZoom), [_onWantCenterAndZoom]);
    const map = useMapEvents({
        zoomend: updateCenterAndZoom,
        dragend: updateCenterAndZoom,
        viewreset: updateCenterAndZoom,
    });
    //меняем размер карты
    useEffect(() => {
        if (isMounted.current) {
            if (width && width != 0 && height && height != 0) {
                map.invalidateSize();
                onSetMapSize({ size: [width, height], device_id });
            }
        }
    }, [width, height, device_id]);
    return null;
});
